import React from 'react';

import ListView from '../shared/lists/ListView';
import PaymentItem from './PaymentItem';
import PaymentEditor from './PaymentEditor';
import useData from '../../utilities/useData';
import postData from '../../utilities/postData';
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import InlineEditorWrapper from '../../utilities/InlineEditorWrapper';
import formatter from '../../utilities/formatter';

const PaymentModal = ({
    data,
    setData,
    newItem,
    setShow,
    fetchData,
    isLoaded
}) => {
    const deleteUrl = `/api/payments/delete`;

    const handleClose = () => setShow(false);

    function deleteItem(itemId) {
        postData(`${deleteUrl}/${itemId}`, null, () => {
            fetchData();
            window.dispatchEvent(new Event('updateChangeLog'));
        });
    }
    const canAdd = data && Array.isArray(data.items) && data.items.filter(i => i.amount === '').length === 0;

    function addNew() {
        const currentData = JSON.parse(JSON.stringify(data));
        if (canAdd) {
            currentData.items.push({ ...newItem });
            setData(currentData);
        }
    }

    const getItems = () => {
        if (!data || !Array.isArray(data.items)) return [];
        return data.items.map((item, index) =>
        (
            <InlineEditorWrapper
                isNew={item.id === 0}
                key={item.id}>
                <PaymentItem
                    fetchData={fetchData}
                    item={item}
                    deleteItem={() => deleteItem(item.id)}
                />
                <PaymentEditor
                    item={item}
                    fetchData={fetchData}
                />
            </InlineEditorWrapper>
        ));
    }

    const tableHead = (
        <thead>
            <tr>
                <th style={{ borderTop: "none" }}>
                    {isLoaded
                        ? (
                            <Row>
                                <Col>Job Total: {formatter.currency(data.total)}</Col>
                                <Col>Balance: {formatter.currency(data.balance)}</Col>
                            </Row>
                        ) : (
                            <Row>
                                <Col>Loading...</Col>
                            </Row>
                        )}
                </th>
                <th style={{ borderTop: "none" }} width="90px;"></th>
            </tr>
        </thead>
    );

    return (
        <Modal size="lg" dialogClassName="payment-modal" show={true} onHide={handleClose}>
            <Modal.Header className="py-1" closeButton>
                <span className="section-title">
                    Payments
                </span>
            </Modal.Header>
            <Modal.Body className="pt-0">
                <ListView
                    tableHead={tableHead}
                    addItem={addNew}
                    canAdd={canAdd}
                    itemName="Payment"
                    items={getItems()}
                    isLoaded={isLoaded}
                />
            </Modal.Body>
        </Modal>
    );
}

export default PaymentModal;

